import React, { Suspense, useState, useEffect, useRef } from "react";
import systemListingService from "./SystemListingServices";
import ThemeColorPicker from "components/Common/ColorPalete2";
import ContractStatusUpsert from "./upsert/ContractStatusUpsert";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function ContractStatus(param: any) {
  const [editingOn, setEditingOn] = useState(false);

  const [contractStatus, SetContractStatus] = useState<any>([]);

  useEffect(() => {

    if (param.activeTab === "Contract Status") {
      ContractStatusSelect()
    }
  }, [param])


  const ContractStatusSelect = () => {
    var payload = {}
    systemListingService.contractStatusList(payload).then((res: any) => { SetContractStatus(res) })
  }

  let [openUpsertUX, setOpenUpsertUX] = useState(false);
  const closeUpsertUX = () => {
    setOpenUpsertUX(!openUpsertUX)
  }


  let [editDataDawer, seteditDataDawer] = useState<any>([]);

  const editPanel = (e: any) => {

    editDataDawer = e
    seteditDataDawer(editDataDawer)
    openUpsertUX = true;
    setOpenUpsertUX(openUpsertUX)
  }

  let [deleteData, setDeleteData] = useState<any>([]);
  let [deleteStatus, setDeleteStatus] = useState(false);
  const deleteSelection = (e: any) => {
    console.log(e)
    deleteData = e
    setDeleteData(deleteData)

    deleteStatus = true;
    setDeleteStatus(deleteStatus)
  }

  const deleteConfirmation = (e: any) => {
    console.log(e)

    //e==1 YES
    console.log(deleteData)
    if (e == 1) {
      systemFormatsList.deletecontractStatus(deleteData).then((respond: any) => {
        CommonUtilities.showToastDawer('Contract Status delete Successfull', 'Success')
      })
    }
    //e==2 NO
    deleteStatus = false;
    setDeleteStatus(deleteStatus)
  }

  const slider_handler = (e: any, selectData: any) => {

    if (e.target.type == "checkbox") {

      selectData[e?.target?.name] = Number(selectData[e?.target?.name]) == 1 ? 0 : 1

      systemListingService.saveContractStatus(selectData).then((repond: any) => {
        ContractStatusSelect();
      })
    }
  }


  return (

    <>
      <div className="content-card ws-12">
        {/* Top edit tab */}
        <div className="ws-12 ptl pbl">
          <span className="text-bold">Contract Status</span>
          <button className={'icon-btn primary pull-right'} type="button" onClick={() => setEditingOn((prev) => !prev)}  >

            <span>{editingOn ? "Edit Mode: On" : "Edit Mode: Off"}</span>
          </button>

          <div className=" ws-12 pt">
            <button className="icon-btn primary height35 pull-right fill" type="button" onClick={() => editPanel({})}>Add Contract Status  </button>
            <button className="btn-save-table hide" type="button" disabled={!editingOn} onClick={() => { setEditingOn(false); }} >Save Changes  </button>
          </div>

        </div>

        {/* Table */}
        <div className="ws-12">
          <table className={editingOn ? "editing-on newTable" : " newTable"}>
            <thead>
              <tr>
                <th >Contract ID</th>
                <th >Contract Status</th>
                <th >Account Summary</th>
                <th >Track Count</th>
                <th >EmailYN</th>
                <th style={{ width: "19%" }}>Operations</th>
              </tr>
            </thead>
            <tbody>
              {contractStatus.map((row: any) => (
                <tr>
                  <td>{row.contractStatusId}</td>
                  <td>
                    <span style={{
                      background: CommonUtilities.lookUpTypeList('contractStatusName', row.statusName, 'bgColor'),
                      color: CommonUtilities.lookUpTypeList('contractStatusName', row.statusName, 'fontColor'),
                      borderRadius: "4px"
                    }} className="pm">
                      {row.statusName}
                    </span>

                  </td>
                  <td>
                    <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                      <input type="checkbox" name="ignoreAccSummary" checked={row?.ignoreAccSummary === 1} onChange={(e: any) => slider_handler(e, row)} />
                      {row?.ignoreAccSummary === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                      {row?.ignoreAccSummary === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                    </label>
                  </td>

                  <td>
                    <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                      <input type="checkbox" name="splitsTable" checked={row?.splitsTable === 1} onChange={(e: any) => slider_handler(e, row)} />
                      {row?.splitsTable === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                      {row?.splitsTable === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                    </label>

                  </td>

                  <td>
                    <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                      <input type="checkbox" name="emailYN" checked={row?.emailYN === 1} onChange={(e: any) => slider_handler(e, row)} />
                      {row?.emailYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                      {row?.emailYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                    </label>
                  </td>

                  <td style={{ opacity: editingOn ? 1 : 0.6 }}  >
                    <div className="width250">
                      <button className={`icon-btn info height40 ${row.isDefault ? "fill" : ""}`} type="button" disabled={!editingOn}>Default</button>
                      <button className="icon-btn edit height40" title="Edit " type="button" disabled={!editingOn} onClick={() => editPanel(row)}>
                        <i className="icon-pencil"></i>
                      </button>
                      <button className="icon-btn delete height40" type="button" disabled={!editingOn} onClick={() => deleteSelection(row)}>
                        <i className="icon-trash"> </i>
                      </button>
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>



      </div>
      {
        (() => {
          if (openUpsertUX) {
            return <ContractStatusUpsert openUpsertUX={openUpsertUX} closeDrawer={closeUpsertUX} editDataDawer={editDataDawer} />
          }

          if (deleteStatus) {
            return <DeleteDialogueBox param={deleteStatus} message={"delete the selected contract status " + deleteData?.statusName} onChange={deleteConfirmation} />
          }
        })()
      }
    </>
  );
};